
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as signupB4YSZRkNKB9FDeS0v8yAB_45DoR_piC_5XlQOStR63J_45MMeta } from "/vercel/path0/pages/signup.vue?macro=true";
import { default as kontaktRZs5r83yacbNIsNajYrbEHA8mCAv1aICZYh_Hhk5SJMMeta } from "/vercel/path0/pages/kontakt.vue?macro=true";
import { default as impressumQLypkw_UsmXf9Ogrgf58zrDqEpxRcZQTEcOQdImnWJgMeta } from "/vercel/path0/pages/impressum.vue?macro=true";
import { default as indexMgTRJkqT2w2vSTj7c5yHeGaHiYRlc5aU5SWggFefOvsMeta } from "/vercel/path0/pages/plattform/leads/index.vue?macro=true";
import { default as indexXpWnmdhLlX6MlO_45ZCKqiGPoZnNwcZJPwpUNrbcovNEsMeta } from "/vercel/path0/pages/plattform/listings/index.vue?macro=true";
import { default as index9WkXH59IuMsLyEFjOuoM0475a9_45uRrrxHNI_45Q4uzIMeta } from "/vercel/path0/pages/plattform/requests/index.vue?macro=true";
import { default as become_45suppliervkRcKwGrfw_E_45IMLcWbm8qXjzd58Q_0lh6znhcXO3FAMeta } from "/vercel/path0/pages/plattform/become-supplier.vue?macro=true";
import { default as indexUvSa5t2ktF5SQa3CjVab5rN1ob1z87unPHkSanvtRuEMeta } from "/vercel/path0/pages/plattform/dashboard/index.vue?macro=true";
import { default as index2vhBAtPcgvs7s0GeFT4_45NOIBSI8ISDn9PXle3FlOowAMeta } from "/vercel/path0/pages/plattform/templates/index.vue?macro=true";
import { default as index8CQS_Cw7wkMpq5U7D9va4sQ7fwIdj3RFX46CRdqBGAUMeta } from "/vercel/path0/pages/plattform/marketplace/index.vue?macro=true";
import { default as indexpockr3d8REWlODoXHzl_45Bb6Bnb6VbGU_R8cRwnwPLAEMeta } from "/vercel/path0/pages/plattform/my-requests/index.vue?macro=true";
import { default as indexjKsx6__45QJH76OsuYDIqGni3jT_qRDV9rJAKF2knO7GUMeta } from "/vercel/path0/pages/plattform/registrieren/index.vue?macro=true";
import { default as indexBySugweH49OCfIYCmeSnkhIQLNclJ4Y6pwm_45Tzey35gMeta } from "/vercel/path0/pages/plattform/listings/[id]/index.vue?macro=true";
import { default as indexVTPnft5TMRIrrrA68L7j8kl9r8I5wCNeCIdcItnnyu0Meta } from "/vercel/path0/pages/plattform/templates/new/index.vue?macro=true";
import { default as index3YsIIxMgOdS88h7CWCDbVahUkt8amFWq1N59I6gNrgoMeta } from "/vercel/path0/pages/plattform/templates/[id]/index.vue?macro=true";
import { default as indexTsPPDKk04PNALpEkLbiaV52VuvOCKkKgyXKVfXCHSGcMeta } from "/vercel/path0/pages/plattform/marketplace/[id]/index.vue?macro=true";
import { default as indexzAnmHGRsodcrc_45Y8SfQZHsAY2NsQA78c9xMhdPRFMmoMeta } from "/vercel/path0/pages/plattform/marketplace/[id]/offer/index.vue?macro=true";
import { default as plattformK4h50H3t_8_459ab_45RM7ns6btiHmNsSPCg2bGS1Cdh3FAMeta } from "/vercel/path0/pages/plattform.vue?macro=true";
import { default as ueber_45unsM5iR6YE79bi5CQBJo9ZxfgPQg2wWUDd6yC091s54fIYMeta } from "/vercel/path0/pages/ueber-uns.vue?macro=true";
import { default as vermietenpa1yRjIZCavkgEMgIZ3tTmNYinKEI61ER_DIxFo6cYMMeta } from "/vercel/path0/pages/vermieten.vue?macro=true";
import { default as mieter_G785UJzxbDY_VED7Je_45KUPQ93MhIOdGVzPyxiXRUxgMeta } from "/vercel/path0/pages/AGB/mieter.vue?macro=true";
import { default as indexDIlA_VwVYEsF82JYYTptIRBexsOVSbsbgl1xBQ_lIIoMeta } from "/vercel/path0/pages/blog/index.vue?macro=true";
import { default as _91slug_93h0D52zVakwJN_wnopjWnhnRsfVtM1z6oSvP_TfBMMp0Meta } from "/vercel/path0/pages/lkw/[slug].vue?macro=true";
import { default as _91slug_93v3ez11IMRk2feKAiBpS9mVspk4W7_E8tt32O22_45Wq2cMeta } from "/vercel/path0/pages/blog/[slug].vue?macro=true";
import { default as datenschutz_45FBZmJbBS5TH216oush549C0lVXULNu5FBxhK_QxWiEMeta } from "/vercel/path0/pages/datenschutz.vue?macro=true";
import { default as _91id_930NEjRxt_45Qro3eHlSVWnnAtIWnMORgGDjDulKGqlB57UMeta } from "/vercel/path0/pages/offers/[id].vue?macro=true";
import { default as welcomeI28I634yiHjj1E9auMhAStT079i_gj1DuozYxi7Gn0UMeta } from "/vercel/path0/pages/auth/welcome.vue?macro=true";
import { default as indexqoKSeLIEiJ7mOMk20JNLL4HbqjBz48ERZZZwSiRaQvYMeta } from "/vercel/path0/pages/offers/index.vue?macro=true";
import { default as vermietervevW7aZd7maVLC7opu1OnRgN_vMTaPNTbj0zeZeVpKYMeta } from "/vercel/path0/pages/AGB/vermieter.vue?macro=true";
import { default as invitationkFX25dMbRpvSSNl0pBkeZl2j0N2jU5RUTRSbcRJse7sMeta } from "/vercel/path0/pages/auth/invitation.vue?macro=true";
import { default as _91slug_930fWs_45laVP8VcyqTYeUBF3kkJMKZCloGRGamhHyCVwWgMeta } from "/vercel/path0/pages/auflieger/[slug].vue?macro=true";
import { default as v1IoWKnLye5WgmrgZpEQT7Bo8dBcH1ZGVPC2v6OjDlt54Meta } from "/vercel/path0/pages/confirm-offer/v1.vue?macro=true";
import { default as v21Y9D7DId168mjPUFTkY82xjsJi5EzOf_456oQcaU3AEwUMeta } from "/vercel/path0/pages/confirm-offer/v2.vue?macro=true";
import { default as _91id_93kysvcWJQbmK_tbxnWYjw4LrbqclxNaNA4OywmU90em4Meta } from "/vercel/path0/pages/confirm-offer/[id].vue?macro=true";
import { default as resetuG5sOEtu4eY9_MncruNXlqOUezv_rnnDEwzu6WO59PMMeta } from "/vercel/path0/pages/auth/password/reset.vue?macro=true";
import { default as indexS58qiVy0eRDdgb1uzwltkletj7FYMzhWyNdAjRLE0s4Meta } from "/vercel/path0/pages/request-quote/index.vue?macro=true";
import { default as recoveryzCNJcp4cJvjjcgC0Bm4Twv3HjEz9_S7iDYsf7g5TpmsMeta } from "/vercel/path0/pages/auth/password/recovery.vue?macro=true";
import { default as _91slug_932NwIY4aAfgcUdKnd0ADtpynCY4bV5tj_45SzJX4UA91_UMeta } from "/vercel/path0/pages/sattelzugmaschinen/[slug].vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/vercel/path0/pages/signup.vue")
  },
  {
    name: "kontakt",
    path: "/kontakt",
    component: () => import("/vercel/path0/pages/kontakt.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/vercel/path0/pages/impressum.vue")
  },
  {
    name: "plattform",
    path: "/plattform",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/plattform.vue"),
    children: [
  {
    name: "plattform-leads",
    path: "leads",
    component: () => import("/vercel/path0/pages/plattform/leads/index.vue")
  },
  {
    name: "plattform-listings",
    path: "listings",
    component: () => import("/vercel/path0/pages/plattform/listings/index.vue")
  },
  {
    name: "plattform-requests",
    path: "requests",
    component: () => import("/vercel/path0/pages/plattform/requests/index.vue")
  },
  {
    name: "plattform-become-supplier",
    path: "become-supplier",
    component: () => import("/vercel/path0/pages/plattform/become-supplier.vue")
  },
  {
    name: "plattform-dashboard",
    path: "dashboard",
    component: () => import("/vercel/path0/pages/plattform/dashboard/index.vue")
  },
  {
    name: "plattform-templates",
    path: "templates",
    component: () => import("/vercel/path0/pages/plattform/templates/index.vue")
  },
  {
    name: "plattform-marketplace",
    path: "marketplace",
    component: () => import("/vercel/path0/pages/plattform/marketplace/index.vue")
  },
  {
    name: "plattform-my-requests",
    path: "my-requests",
    meta: indexpockr3d8REWlODoXHzl_45Bb6Bnb6VbGU_R8cRwnwPLAEMeta || {},
    component: () => import("/vercel/path0/pages/plattform/my-requests/index.vue")
  },
  {
    name: "plattform-registrieren",
    path: "registrieren",
    component: () => import("/vercel/path0/pages/plattform/registrieren/index.vue")
  },
  {
    name: "plattform-listings-id",
    path: "listings/:id()",
    component: () => import("/vercel/path0/pages/plattform/listings/[id]/index.vue")
  },
  {
    name: "plattform-templates-new",
    path: "templates/new",
    meta: indexVTPnft5TMRIrrrA68L7j8kl9r8I5wCNeCIdcItnnyu0Meta || {},
    component: () => import("/vercel/path0/pages/plattform/templates/new/index.vue")
  },
  {
    name: "plattform-templates-id",
    path: "templates/:id()",
    meta: index3YsIIxMgOdS88h7CWCDbVahUkt8amFWq1N59I6gNrgoMeta || {},
    component: () => import("/vercel/path0/pages/plattform/templates/[id]/index.vue")
  },
  {
    name: "plattform-marketplace-id",
    path: "marketplace/:id()",
    component: () => import("/vercel/path0/pages/plattform/marketplace/[id]/index.vue")
  },
  {
    name: "plattform-marketplace-id-offer",
    path: "marketplace/:id()/offer",
    component: () => import("/vercel/path0/pages/plattform/marketplace/[id]/offer/index.vue")
  }
]
  },
  {
    name: "ueber-uns",
    path: "/ueber-uns",
    component: () => import("/vercel/path0/pages/ueber-uns.vue")
  },
  {
    name: "vermieten",
    path: "/vermieten",
    component: () => import("/vercel/path0/pages/vermieten.vue")
  },
  {
    name: "AGB-mieter",
    path: "/AGB/mieter",
    component: () => import("/vercel/path0/pages/AGB/mieter.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/pages/blog/index.vue")
  },
  {
    name: "lkw-slug",
    path: "/lkw/:slug()",
    component: () => import("/vercel/path0/pages/lkw/[slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/vercel/path0/pages/blog/[slug].vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/vercel/path0/pages/datenschutz.vue")
  },
  {
    name: "offers-id",
    path: "/offers/:id()",
    component: () => import("/vercel/path0/pages/offers/[id].vue")
  },
  {
    name: "auth-welcome",
    path: "/auth/welcome",
    component: () => import("/vercel/path0/pages/auth/welcome.vue")
  },
  {
    name: "offers",
    path: "/offers",
    meta: indexqoKSeLIEiJ7mOMk20JNLL4HbqjBz48ERZZZwSiRaQvYMeta || {},
    component: () => import("/vercel/path0/pages/offers/index.vue")
  },
  {
    name: "AGB-vermieter",
    path: "/AGB/vermieter",
    component: () => import("/vercel/path0/pages/AGB/vermieter.vue")
  },
  {
    name: "auth-invitation",
    path: "/auth/invitation",
    component: () => import("/vercel/path0/pages/auth/invitation.vue")
  },
  {
    name: "auflieger-slug",
    path: "/auflieger/:slug()",
    component: () => import("/vercel/path0/pages/auflieger/[slug].vue")
  },
  {
    name: "confirm-offer-v1",
    path: "/confirm-offer/v1",
    component: () => import("/vercel/path0/pages/confirm-offer/v1.vue")
  },
  {
    name: "confirm-offer-v2",
    path: "/confirm-offer/v2",
    component: () => import("/vercel/path0/pages/confirm-offer/v2.vue")
  },
  {
    name: "confirm-offer-id",
    path: "/confirm-offer/:id()",
    component: () => import("/vercel/path0/pages/confirm-offer/[id].vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password/reset",
    component: () => import("/vercel/path0/pages/auth/password/reset.vue")
  },
  {
    name: "request-quote",
    path: "/request-quote",
    component: () => import("/vercel/path0/pages/request-quote/index.vue")
  },
  {
    name: "auth-password-recovery",
    path: "/auth/password/recovery",
    component: () => import("/vercel/path0/pages/auth/password/recovery.vue")
  },
  {
    name: "sattelzugmaschinen-slug",
    path: "/sattelzugmaschinen/:slug()",
    component: () => import("/vercel/path0/pages/sattelzugmaschinen/[slug].vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/elektro/:pathMatch(.*)",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]